import React from 'react';
import { formatPhoneNumber } from '../../helpers/utils';

type StudentCheckboxProps = {
  onCheckboxClicked: () => void;
  checkboxValue: boolean;
  firstName: string;
  lastName: string;
  parentPhone: string;
};

const StudentCheckbox = ({
  onCheckboxClicked,
  checkboxValue,
  firstName,
  lastName,
  parentPhone,
}: StudentCheckboxProps) => {
  return (
    <div className="inline-block h-16">
      <input
        id={`checkbox-${firstName}-${lastName}-${parentPhone}`}
        type="checkbox"
        checked={checkboxValue}
        className="mt-auto mb-auto w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 align-middle"
        onChange={onCheckboxClicked}
      />
      <label
        htmlFor={`checkbox-${firstName}-${lastName}-${parentPhone}`}
        className="mt-auto mb-auto ml-4 ms-2 text-m font-medium align-middle"
      >
        {firstName} {lastName} {formatPhoneNumber(parentPhone)}
      </label>
    </div>
  );
};

export default StudentCheckbox;
